import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const create_new_ministry = async (body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry`,
        method: "POST",
        body: JSON.stringify(body)
    })
}

export const get_all_ministries = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry`,
        method: "GET"
    })
}

export const get_ministry_by_id = async (id) => {
    if (!id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/id/${id}`,
        method: "GET"
    })
}

export const update_ministry = async (id, body) => {
    if (!id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/id/${id}`,
        method: "PUT",
        body: JSON.stringify(body)
    })
}

export const delete_ministry = async (id) => {
    if (!id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/id/${id}`,
        method: "DELETE"
    })
}

export const fetch_ministry_servers = async (ministry_id) => {
    if (!ministry_id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/servers/${ministry_id}`,
        method: "GET"
    })
}

export const create_ministry_server = async (body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/servers`,
        method: "POST",
        body: JSON.stringify(body)
    })
}

export const update_ministry_server = async (id, body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/servers/id/${id}`,
        method: "PUT",
        body: JSON.stringify(body)
    })
}

export const delete_ministry_server = async (id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/servers/id/${id}`,
        method: "DELETE"
    })
}

export const fetch_user_ministry_servers = async (user_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/servers/user/${user_id}`,
        method: "GET"
    })
}

export const upload_ministries_csv = async (csv_text, mode = "add") => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/upload-csv`,
        method: "POST",
        body: JSON.stringify({ csv_text, mode })
    })
}
